<script setup lang="ts">
import DraftsList from '../../drafts/DraftsList/DraftsList.vue';
import PublicTitlePanel from '@/dashboard/vue/components/public/PublicTitlePanel/PublicTitlePanel.vue';
import PublicLimitBanner from '@/dashboard/vue/components/public/PublicLimitBanner.vue';
import CardIcon from '@/dashboard/vue/components/icons/CardIcon.vue';
import GridIcon from '@/dashboard/vue/components/icons/GridIcon.vue';
import GroupDraftsManagePanel from '@/dashboard/vue/components/drafts/GroupDraftsManagePanel.vue';
import { usePublicMainDraft } from '@/dashboard/vue/components/public/PublicMainDraft/usePublicMainDraft';
import PublicSubscriptionPastDueBanner from '@/dashboard/vue/components/public/PublicSubscriptionPastDueBanner.vue';
import { OwnerRole } from '@/dashboard/constants/roles';

const {
  project,
  workspace,
  showUploadLimitBanner,
  loading,
  mobileColumns,
  currentWorkspaceUser,
  checkedDrafts,
  groupedBulkMoveProjects,
  changeColumnsView,
  selectAll,
  uncheckAll,
  moveSelectedDrafts,
  deleteSelectedDrafts,
} = usePublicMainDraft();
</script>

<template>
  <div class="w-full">
    <div class="pointer-events-none fixed left-zero top-s z-[1002] hidden w-full justify-center max-tablet:flex">
      <button class="pointer-events-auto stroke-black dark:stroke-gray-700" @click="() => changeColumnsView()">
        <CardIcon v-if="mobileColumns" class="stroke-black dark:stroke-gray-700" />
        <GridIcon v-else class="stroke-black dark:stroke-gray-700" />
      </button>
    </div>

    <GroupDraftsManagePanel
      v-if="checkedDrafts.length > 0"
      :count="checkedDrafts.length"
      :group-move-items="groupedBulkMoveProjects"
      :select-all="selectAll"
      :uncheck="uncheckAll"
      :deletion="deleteSelectedDrafts"
      :move-to="moveSelectedDrafts"
    />
    <PublicTitlePanel v-if="project" />

    <PublicLimitBanner v-if="workspace" :show="showUploadLimitBanner" :workspace="workspace" :workspace-user="currentWorkspaceUser" />
    <PublicSubscriptionPastDueBanner
      :show="!!project && !!project.user && project.subscription?.status === 'past_due' && OwnerRole.includes(project.user.role)"
    />

    <DraftsList :group-move-items="groupedBulkMoveProjects" />

    <div class="h-l max-tablet:h-[74px]"></div>

    <div v-if="loading" class="pointer-events-none fixed bottom-s left-[0px] z-[1002] flex w-full justify-center">
      <div class="tppr-banner pointer-events-auto rounded-8 bg-white dark:bg-gray-900">
        <div class="tppr-banner__content h-xxl">
          <span class="mr-[12px] text-[16px]">🕐</span>
          <span class="text-caption-s mr-s text-black dark:text-white">Loading</span>
        </div>
      </div>
    </div>
  </div>
</template>
